import { unique } from '@portals-platform/utils';
import type { CertificateTemplateResponse } from '../../data-access/api/responses.js';
import { FIELD_CONFIG, TEMPLATE_FIELD_KEYS } from './fields.js';
import type { DynamicFieldKey, FieldsBySection } from './types.js';

export const getNormalizedTemplateFieldKey = (field: string): DynamicFieldKey | null =>
  TEMPLATE_FIELD_KEYS[field] ?? null;

export const getDynamicFieldKeysForTemplate = (
  template: CertificateTemplateResponse | null,
): DynamicFieldKey[] => {
  if (!template) {
    return [];
  }

  const fieldKeys = template.requiredTemplateFields
    .map(getNormalizedTemplateFieldKey)
    .filter((fieldKey): fieldKey is DynamicFieldKey => fieldKey !== null);

  return unique(fieldKeys);
};

export const groupFieldsBySection = (fieldKeys: DynamicFieldKey[]): FieldsBySection => {
  const grouped: FieldsBySection = {
    situation: [],
    coverageLimits: [],
    storageCoverage: [],
    compliance: [],
    additional: [],
  };

  for (const fieldKey of fieldKeys) {
    grouped[FIELD_CONFIG[fieldKey].section].push(fieldKey);
  }

  return grouped;
};
